<!--
 * @Author: your name
 * @Date: 2021-09-20 08:59:53
 * @LastEditTime: 2021-12-01 14:34:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Bounty\src\views\PC\Skills\Skills.vue
-->
<template>
  <div class="bounty-schema-tip">
    <div class="bounty-bk" @click="close"></div>
    <div class="bounty-con">
      <div class="tip-title">
        <span></span>
        <svg @click="close" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M17.25 17.2498L6.75 6.74982" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M17.25 6.74982L6.75 17.2498" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
      <div class="content">
        <el-form ref="form" :label-position="'top'" class="form_wrap">
          <el-form-item class="required" :label="$t('planDialog.RejectReason')">
            <el-input maxlength="200" v-model="formData.programmeDetails" @input="changeInput"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer mt24">
        <div class="cancel-btn btnb" @click="close">{{$t('planDialog.Cancel')}}</div>
        <div class="ok-btn btnb" @click="sure">{{$t('planDialog.Submit')}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bountyRejectTip',
  data () {
    return {
      formData: {
        programmeDetails: ''
      }
    }
  },
  mounted () {
    // this.formData.programmeDetails = '';
  },
  props: {
  },
  methods: {
    /**
     * @description: 关闭
     * @param {*}
     * @return {*}
     */
    close () {
      this.$emit('close')
    },
    /**
     * @description:
     * @param {*}
     * @return {*}
     */
    checkForm () {
      if (!this.formData.programmeDetails) {
        this.$message({
          type: 'warning',
          offset: 120,
          message: this.$t('allTip.tip26')
        })
        return false
      }
      return true
    },
    /**
     * @description: 提交todo
     * @param {*}
     * @return {*}
     */
    changeInput () {
      this.$emit('input', this.formData.programmeDetails)
    },
    /**
     * @description: 确认
     * @param {*}
     * @return {*}
     */
    sure () {
      if (!this.checkForm()) {
        return false
      }
      this.$emit('sure')
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/gloabal.scss';
.bounty-schema-tip .el-form-item{
  text-align: left;
  margin-bottom: 0;
}
.bounty-schema-tip .completeAttachment .el-form-item__content{
  width: 120px;
}
.bounty-schema-tip .el-input__inner{
  font-family: $fontFamilyCircularStd !important;
  height: 48px !important;
  line-height: 48px !important;
  background: #35353D;
  border-radius: 12px;
  border: 1px solid #35353D !important;
  color: #fff;
}
</style>
<style scoped lang="scss">
@import '@/assets/css/gloabal.scss';
.mt24{
  margin-top: 24px;
}
.bounty-schema-tip{
  .bounty-bk{
    background: rgba(0, 0, 0, 0.6);
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
  }
  .bounty-con{
    background: linear-gradient(90deg, #26252B 0%, #26272A 100%);
    border-radius: 24px;
    width: 600px;
    position: fixed;
    top: 50%;
    left: 50%;
    z-index: 11;
    transform: translate(-300px,-50%);
    .tip-title{
      height: 70px;
      display: flex;
      padding: 0  30px;
      justify-content: space-between;
      align-items: center;
      svg{
        cursor: pointer;
      }
    }
    .content{
      padding: 10px 90px;
      color: #fff;
      font-family: $fontFamilyCircularStd;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      text-align: center;
    }
    .footer{
      text-align: center;
      padding-bottom: 60px;
      // margin: 0 auto;
      // width: 20vw;
      padding-left: 90px;
      padding-right: 90px;
      display: flex;
      justify-content: space-around;
      .btnb{
        font-family: $fontFamilyCircularStd;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        // width: 110px;
        padding: 0 20px;
        height: 40px;
        line-height: 40px;
        border-radius: 20px;
        text-align: center;
        float: left;
        cursor: pointer;
      }
      .cancel-btn{
        background: #4C4C55;
      }
      .ok-btn{
         background: linear-gradient(93.58deg, #A737FF 0%, #18D6BE 100%);
      }
    }
  }
}
.img_upload .el-upload {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  svg{
    width: 60px;
    height: 60px;
  }
  i {
    margin-top: 8px;
    font-size: 50px;
  }
  img{
    display: block;
    width: 120px;
    height: 120px;
    border-radius: 8px;
  }
}
.avatar{
  margin-top: 24px;
  text-align: left;
  a{
    color: #fff;
  }
}
.el-textarea__inner,.el-input__inner,.el-range-input,.el-input-group__append,.el-form-item__content{
  background: #1C1C20 !important;
  border-radius: 8px !important;
  color: #fff !important;
  border-color: #1C1C20 !important;
  font-family: $fontFamilyCircularStd !important;
  &:focus{
    border-color: #1a796f !important;
    outline: 0;
  }
}
</style>
